import classNames from 'classnames/bind'

import Styles from './MyAssetTooltipGradation.module.scss'

import type {CSSProperties, ReactNode} from 'react'

const cx = classNames.bind(Styles)

interface MyAssetTooltipGradationProps {
    edgePosition?: CSSProperties
    tooltipPosition?: CSSProperties
    direction: 'top' | 'right' | 'bottom' | 'left'
    children: ReactNode
}

const MyAssetTooltipGradation = ({
    children,
    direction,
    edgePosition,
    tooltipPosition,
}: MyAssetTooltipGradationProps) => {
    return (
        // [M] 레이어팝업 위치는 import되는 component에서 tooltipPosition로 적용
        <span className={cx('article')} style={tooltipPosition}>
            {/* [M] 화살표 위치 left, right는 edgePosition의 top 조정,
                    화살표 위치 top, bottom은 edgePosition의 left, right 조정 */}
            <span className={cx('icon-edge', direction)} style={edgePosition} />
            <span className={cx('text')}>{children}</span>
        </span>
    )
}

export default MyAssetTooltipGradation
